import styles from "./accountDetails.module.css";
import "../../../variables.css";
import { tWithKeyAttr as t } from "../../../i18nHelper";
import { useState } from "react";
import { InvoicesTab } from './tabs/InvoicesTab';
import { PaymentDetailsTab } from './tabs/PaymentDetailsTab';
import { ActiveServicesTab } from './tabs/ActiveServicesTab';
import { SubscriptionTab } from './tabs/SubscriptionTab';
import { PlanUsageTab } from './tabs/PlanUsageTab';
import { LoginHistoryTab } from './tabs/LoginHistoryTab';
import { NotificationsTab } from './tabs/NotificationsTab';
import { BuyCreditsTab } from './tabs/BuyCreditsTab';
import { SeatPacksTab } from './tabs/SeatPacksTab';
import { CreditPurchaseHistoryTab } from './tabs/CreditPurchaseHistoryTab';
import CloseButton from "../../closeButton/closeButton";
import { accountCategories } from "../../myAccount/myAccount";

interface AccountDetailsProps {
  onClose: () => void;
  activeTab: 'invoices' | 'payment' | 'subscription' | 'planUsage' | 'services' | 'loginHistory' | 'notifications' | string;
}

function AccountDetails({ onClose, activeTab }: AccountDetailsProps) {
  const [currentTab, setCurrentTab] = useState<string>(activeTab);
  
  return (
    <article className={styles.container}>
        <CloseButton onClick={onClose} />
      <div className={styles.tabsContainer}>
        {accountCategories.map((tab) => (
          <button
            key={tab.id}
            className={`${styles.tabButton} ${currentTab === tab.id ? styles.activeTab : ''}`}
            onClick={() => setCurrentTab(tab.id)}
            >
            {t(tab.title)}
          </button>
        ))}
      </div>
      <div className={styles.tabContent}>
        {currentTab === "invoices" && <InvoicesTab />}
        {currentTab === "payment" && <PaymentDetailsTab onNavigateToTab={setCurrentTab} />}
        {currentTab === "subscription" && <SubscriptionTab />}
        {currentTab === "plan-usage" && <PlanUsageTab />}
        {currentTab === "buy-credits" && <BuyCreditsTab onNavigateToTab={setCurrentTab} />}
        {currentTab === "seat-packs" && <SeatPacksTab onNavigateToTab={setCurrentTab} />}
        {currentTab === "credit-purchases" && <CreditPurchaseHistoryTab />}
        {currentTab === "services" && <ActiveServicesTab />}
        {currentTab === "loginHistory" && <LoginHistoryTab />}
        {currentTab === "notifications" && <NotificationsTab />}
      </div>
    </article>
  );
}

export default AccountDetails;
